import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { captureUtmFromUrl } from "@/lib/utm";
import Home from "@/pages/Home";
import AdminGallery from "@/pages/AdminGallery";
import AdminOrcamentos from "@/pages/AdminOrcamentos";
import AdminContatos from "@/pages/AdminContatos";
import AdminNewsletter from "@/pages/AdminNewsletter";
import AdminLayout from "@/components/admin/AdminLayout";
import { AdminAuthProvider } from "@/hooks/useAdminAuth";
import ProductDetail from "@/pages/ProductDetail";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import Catalog from "@/pages/Catalog";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import TermsOfUse from "@/pages/TermsOfUse";
import CookiePolicy from "@/pages/CookiePolicy";
import { CookieConsentProvider } from "@/hooks/useCookieConsent";
import CookieConsentBanner from "@/components/site/CookieConsentBanner";

function App() {
  // Captura os utm_* da URL de entrada uma vez, no boot — não de novo a
  // cada navegação interna do React Router. Ver lib/utm.js.
  useEffect(() => {
    captureUtmFromUrl();
  }, []);

  return (
    <CookieConsentProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/catalogo" element={<Catalog />} />
          <Route path="/produtos/:slug" element={<ProductDetail />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/politica-de-privacidade" element={<PrivacyPolicy />} />
          <Route path="/termos-de-uso" element={<TermsOfUse />} />
          <Route path="/politica-de-cookies" element={<CookiePolicy />} />

          <Route
            path="/admin"
            element={
              <AdminAuthProvider>
                <AdminLayout />
              </AdminAuthProvider>
            }
          >
            <Route index element={<Navigate to="galeria" replace />} />
            <Route path="galeria" element={<AdminGallery />} />
            <Route path="orcamentos" element={<AdminOrcamentos />} />
            <Route path="contatos" element={<AdminContatos />} />
            <Route path="newsletter" element={<AdminNewsletter />} />
          </Route>

          <Route path="*" element={<Home />} />
        </Routes>
        <CookieConsentBanner />
      </BrowserRouter>
      <Toaster richColors position="top-right" theme="light" />
    </CookieConsentProvider>
  );
}

export default App;
